<template>
    <div class="relative flex flex-col items-center">
        <img :id="idImagemOrigem" :src="imagem" style="width: 100%;" />
        <img :ref="refComponente" :src="imagem" style="width: 100%; position: absolute;" @click="exibirAreaMarcacao" />
    </div>
</template>

<script>
import { defineComponent, ref } from 'vue';
import * as markerjs2 from 'markerjs2';

export default defineComponent({
    props: {
        largura: {
            type: String,
            required: true
        },
        altura: {
            type: String,
            required: true
        },
        imagem: {
            type: String,
            required: true
        },
        idImagemOrigem: {
            type: String,
            required: true
        },
        refComponente: {
            type: String,
            required: true
        }
    },
    emits: ['ultimaImagem'],
    methods: {
        exibirAreaMarcacao() {
            const imagemOrigem = document.getElementById(this.idImagemOrigem);           
            const markerArea = new markerjs2.MarkerArea(imagemOrigem);
            markerArea.renderAtNaturalSize = true;
            markerArea.renderImageType = 'image/png';
            markerArea.settings.displayMode = 'popup';
            markerArea.settings.popupMargin = 10;
            markerArea.targetRoot = imagemOrigem.parentElement;
            markerArea.availableMarkerTypes = [markerjs2.FreehandMarker, markerjs2.ArrowMarker, markerjs2.TextMarker];
            markerjs2.FreehandMarker.title = "Desenho livre";
            markerjs2.ArrowMarker.title = "Seta";
            markerjs2.TextMarker.title = "Texto";
            markerArea.uiStyleSettings.okButtonColor = '#47A817';
            
            markerArea.addEventListener("show", () => {
                document.querySelectorAll("a[href='https://markerjs.com/']")[0].parentElement.remove();
                document.querySelectorAll(".__markerjs2_ div[data-action='select']")[0].title = 'Selecionar';
                document.querySelectorAll(".__markerjs2_ div[data-action='delete']")[0].title = 'Remover';
                document.querySelectorAll(".__markerjs2_ div[data-action='undo']")[0].title = 'Desfazer';
                document.querySelectorAll(".__markerjs2_ div[data-action='render']")[0].title = 'Salvar e fechar';
                document.querySelectorAll(".__markerjs2_ div[data-action='close']")[0].title = 'Fechar';
            });
            
            markerArea.addEventListener('render', event => {
                this.$refs[this.refComponente].src = event.dataUrl;
                this.estadoUltimaMarcacao[this.refComponente] = event.state;
            });
            
            markerArea.addEventListener("beforeclose", (event) => {
                event.preventDefault();
                this.$confirm("Deseja descartar as alterações?", "", "question", {
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não"
                }).then(() => {
                    markerArea.close(true);                    
                }, () => {
                    return;                    
                });
            });
            
            markerArea.addEventListener("close", () => {
                if (this.estadoUltimaMarcacao[this.refComponente]) {
                    this.$emit('ultimaImagem', {
                        refComponente: this.refComponente, 
                        ultimaMarcacao: this.estadoUltimaMarcacao[this.refComponente],
                        dataUrl: this.$refs[this.refComponente].src
                    });
                }
            });

            markerArea.show();  

            if (this.estadoUltimaMarcacao[this.refComponente]) {
                markerArea.restoreState(this.estadoUltimaMarcacao[this.refComponente]);
            }
        },
    },
    setup() {        
        const estadoUltimaMarcacao = ref([]);
        // document.getElementsByTagName("https://markerjs.com/").parentElement.remove();

        return { estadoUltimaMarcacao };
    }
});
</script>